import React from "react";
import { NavLink } from "react-router-dom";

export default function ExcelDashboardTraining() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Advanced MS Excel Dashboards & Corporate Training</h1>
            <h5 className="text-muted">
              Drive Business Efficiency with Interactive Dashboards and Expert-Led Training
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Description */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/data-analytics-report-illustration_335657-4306.jpg"
              alt="Excel Dashboards"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Make Excel Work Smarter for You</h2>
            <p>
              At <strong>Bytlas Intelligence</strong>, we transform traditional spreadsheets into dynamic, automated dashboards using advanced Excel techniques and best practices. Our corporate training programs are tailored to boost data literacy and productivity.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Dashboard Creation with Pivot Tables & Charts</li>
              <li className="list-group-item">✅ VBA Automation for Reporting</li>
              <li className="list-group-item">✅ Excel Power Query & Power Pivot</li>
              <li className="list-group-item">✅ Training Customized for Departments & Roles</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Corporate Training Modules</h3>
            <p>
              We deliver structured sessions for teams in finance, HR, operations, and sales. Sessions include hands-on exercises, project-based learning, and real-world business scenarios.
            </p>
            <ul>
              <li>📊 Data Visualization Techniques</li>
              <li>📅 Automated Monthly/Weekly Reports</li>
              <li>🔄 Data Cleansing & Transformation</li>
              <li>🧮 Advanced Formulas & Lookup Functions</li>
              <li>🔐 Excel Security & Protected Views</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Why Train with Bytlas?</h3>
            <ul>
              <li>🎓 Expert Trainers with Industry Experience</li>
              <li>📝 Post-Training Assessment & Certification</li>
              <li>🏢 On-Site or Online Corporate Workshops</li>
              <li>📂 Custom Training Materials & Templates</li>
              <li>🧩 Integration with Power BI & MS Access (Optional)</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Enroll Your Team or Request a Demo
          </NavLink>
        </div>
      </div>
    </section>
  );
}
